import { useAxios } from './axiosService';

// SC-QA-27: upgrade a Standard order to Complete for 1 credit
export const UPGRADE_ERROR_CODES = {
    ALREADY_COMPLETE: 'UPGRADE_ALREADY_COMPLETE',
    NOT_POSSIBLE: 'UPGRADE_NOT_POSSIBLE',
    NO_INTERNAL_DATA: 'UPGRADE_NO_INTERNAL_DATA',
    // POST /jobs/report for Complete when the user already has a Standard order for the VIN
    EXISTING_ORDER: 'UPGRADE_EXISTING_ORDER',
};

export const useUpgradeService = () => {
    const { axios } = useAxios();

    // { canUpgrade, jobUuid, price, sections }
    const getUpgradeOffer = async vin => (await axios.get(`/upgrade/offer/${encodeURIComponent(vin)}`)).data;

    // { uuid, vin, type: 'combined' }
    const upgradeToComplete = async jobUuid => (await axios.post(`/upgrade/${jobUuid}`)).data;

    return { getUpgradeOffer, upgradeToComplete };
};
